import toastr from "toastr";
import "toastr/build/toastr.min.css";
import { COLORS } from "../assets/theme";

toastr.options = {
  closeButton: true,
  debug: false,
  newestOnTop: true,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: true,
  showDuration: 300,
  hideDuration: 300,
  timeOut: 3000,
  extendedTimeOut: 1000,
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

const customStyles = () => {
  const style = document.createElement("style");
  style.innerHTML = `
    .toast {
      background-color: ${COLORS.BlackBackground} !important;
      color: ${COLORS.textPrimary} !important;
      border-radius: 8px;
      font-family: 'Arial', sans-serif;
    }
    .toast-success {
      border-left: 5px solid ${COLORS.GOLD} !important;
    }
    .toast-error {
      border-left: 5px solid red !important;
    }
    .toast-warning {
      border-left: 5px solid orange !important;
    }
    .toast-close-button {
      color: ${COLORS.iconColor} !important;
    }
  `;
  document.head.appendChild(style);
};

customStyles();

// TypeScript Interfaces
export interface ToastOptions {
  timeOut?: number;
  extendedTimeOut?: number;
  closeButton?: boolean;
  progressBar?: boolean;
  positionClass?: string;
  preventDuplicates?: boolean;
  showDuration?: number;
  hideDuration?: number;
  showEasing?: string;
  hideEasing?: string;
  showMethod?: string;
  hideMethod?: string;
}

// ToastNotification Utility
const ToastNotification = {
  success: (
    message: string | JQuery<HTMLElement>,
    options: ToastOptions = {}
  ) => {
    toastr.success(message, "Success", { timeOut: 2000, ...options });
  },
  error: (
    message: string | JQuery<HTMLElement>,
    options: ToastOptions = {}
  ) => {
    toastr.error(message, "Error", { timeOut: 5000, ...options });
  },
  warning: (
    message: string | JQuery<HTMLElement>,
    options: ToastOptions = {}
  ) => {
    toastr.warning(message, "Warning", { timeOut: 3000, ...options });
  },
  info: (message: string | JQuery<HTMLElement>, options: ToastOptions = {}) => {
    toastr.info(message, "Info", { timeOut: 3000, ...options });
  },
};

export default ToastNotification;
